import React, { useState } from "react";
import { RefreshCw, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const TONE = { brouillon: "bg-gray-100 text-gray-700", envoye: "bg-sky-50 text-sky-700", vu: "bg-indigo-50 text-indigo-700", signe: "bg-emerald-50 text-emerald-700",
  refuse: "bg-red-50 text-red-700", expire: "bg-amber-50 text-amber-800", annule: "bg-gray-100 text-gray-500" };

export default function SignatureStatus({ sig, onChange }) {
  const [busy, setBusy] = useState(null);
  const act = async (kind) => {
    setBusy(kind);
    try { await api.post(`/signatures/${sig.id}/${kind}`); toast.success(kind === "remind" ? "Relance envoyée par Yousign" : "Statut actualisé"); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Action impossible"); }
    finally { setBusy(null); }
  };
  const open = ["envoye", "vu"].includes(sig.status);
  return (
    <span className="inline-flex items-center gap-1" data-testid={`sig-status-${sig.doc_id}`}>
      <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${TONE[sig.status] || ""}`} title={`Yousign · ${sig.signer?.email || ""}`} data-testid={`sig-badge-${sig.doc_id}`}>{sig.status_label}</span>
      {open && <button onClick={() => act("remind")} className="p-1 rounded hover:bg-norea-surfaceHover" title="Relancer le client" data-testid={`sig-remind-${sig.doc_id}`}>{busy === "remind" ? <Loader2 className="w-3 h-3 animate-spin" /> : <BellRing className="w-3 h-3" />}</button>}
      {open && <button onClick={() => act("sync")} className="p-1 rounded hover:bg-norea-surfaceHover" title="Actualiser" data-testid={`sig-sync-${sig.doc_id}`}>{busy === "sync" ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />}</button>}
    </span>
  );
}
